import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { SettingModelSettingType, SolvePanelPlacementModelGapPositionPreferences } from 'api/models';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const gapModeOptions = Object.values(SolvePanelPlacementModelGapPositionPreferences);

export const PanelPlacementSettings = () => {
    const { t } = useTranslation();

    const {
        selectedSettingType,
        automatedPlacementSettingsByType,
        setAutomatedPanelGapPositionPreferences,
        setAutomatedPanelRequireVerticalGap
    } = usePlacementStore(
        useShallow((state) => ({
            selectedSettingType: state.selectedSettingType,
            automatedPlacementSettingsByType: state.automatedPlacementSettingsByType,
            setAutomatedPanelGapPositionPreferences: state.setAutomatedPanelGapPositionPreferences,
            setAutomatedPanelRequireVerticalGap: state.setAutomatedPanelRequireVerticalGap
        }))
    );

    const panelSettings = automatedPlacementSettingsByType.Panels;

    if (selectedSettingType !== SettingModelSettingType.Panels) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2">
            <div className="rounded-sm border border-border-ultra-light bg-background-gray-ultra-light p-2">
                <div className="mb-1 font-semibold text-xs uppercase tracking-wide">{t('labelGapPlacement')}</div>

                <div className="mb-2 rounded-sm border border-(--color-border-accent-light) bg-background-action-hover/40 px-2 py-1.5">
                    <div className="relative px-1">
                        <div className="absolute left-4 right-4 top-[8px] h-[2px] rounded-full bg-(--color-border-accent-light)" />
                        <div className="relative grid grid-cols-5 gap-0.5">
                            {gapModeOptions.map((mode) => (
                                <label
                                    key={mode}
                                    className="flex cursor-pointer flex-col items-center gap-0.5 text-center text-[10px] leading-tight"
                                >
                                    <input
                                        checked={panelSettings.gapPositionPreferences === mode}
                                        className="peer sr-only"
                                        name="automated-solver-gap-mode"
                                        type="radio"
                                        onChange={() => setAutomatedPanelGapPositionPreferences(mode)}
                                    />
                                    <span className="z-10 flex h-4.5 w-4.5 items-center justify-center rounded-full border-2 border-(--color-border-accent) bg-white shadow-sm transition peer-checked:scale-110 peer-checked:border-(--color-border-accent) peer-checked:bg-(--color-border-accent)" />
                                    <span className="max-w-14 text-[9px] text-text-gray-dark peer-checked:font-semibold peer-checked:text-text-default">
                                        {t(`labelGapMode${mode}`)}
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-x-2">
                    <Checkbox
                        checked={panelSettings.requireVerticalGap}
                        label={t('labelRequireVerticalGap')}
                        styles={{
                            label: {
                                fontSize: '14px'
                            }
                        }}
                        onChange={(event) => setAutomatedPanelRequireVerticalGap(event.target.checked)}
                    />
                </div>
            </div>
        </div>
    );
};
